import { colors } from '../../styles/theme';
import GuideLayout, { GuideStep } from './GuideLayout';

const surucuSteps: GuideStep[] = [
  { id: 1, title: 'Uygulamayı İndir', description: 'Google Play veya App Store\'dan YolSepetiGO Sürücü uygulamasını indirin.', image: '/images/driver-app/1.png' },
  { id: 2, title: 'Kayıt Ol', description: 'Telefon numaranızla kayıt olun ve kişisel bilgilerinizi girin.', image: '/images/driver-app/2.png' },
  { id: 3, title: 'Belgelerinizi Yükleyin', description: 'Ehliyet, ruhsat ve gerekli belgeleri sisteme yükleyin.', image: '/images/driver-app/3.png' },
  { id: 4, title: 'Onay Bekleyin', description: 'Başvurunuz inceleniyor. Onay sürecini takip edin.', image: '/images/driver-app/4.png' },
  { id: 5, title: 'İş Almaya Başlayın', description: 'Onay aldıktan sonra gelen talepleri kabul edip kazanmaya başlayın!', image: '/images/driver-app/5.png' },
];

export default function SurucuGuidePage() {
  return (
    <GuideLayout
      service="surucu"
      seo={{
        title: 'Sürücü Olarak Nasıl Başlarım?',
        description: 'YolSepetiGO sürücü uygulamasını kullanarak nasıl iş alırsınız? 5 adımda sürücü olun.',
        keywords: ['sürücü başvuru', 'çekici sürücüsü', 'vinç operatörü', 'nakliye şoförü'],
      }}
      breadcrumb="Sürücü"
      title="Sürücü Olarak Nasıl Başlarım?"
      subtitle="5 kolay adımda YolSepetiGO ailesine katılın ve kazanmaya başlayın!"
      accent={{
        from: colors.secondary[500],
        to: colors.secondary[700],
        soft: colors.secondary[50],
        border: colors.secondary[200],
        strong: colors.secondary[700],
        text: colors.secondary[900],
      }}
      steps={surucuSteps}
      tipsTitle="Sürücü İpuçları"
      tips={[
        'Belgelerinizi net ve okunabilir şekilde fotoğraflayın.',
        'Profil fotoğrafınızı profesyonel tutun.',
        'Müşteri puanlarınızı yüksek tutmak için zamanında gidin.',
        'Uygulamayı aktif tutarak daha fazla talep alın.',
      ]}
      cta={{
        title: 'Hemen Sürücü Olun!',
        text: 'YolSepetiGO ailesine katılın, kendi işinizin patronu olun.',
        label: 'Başvuru Yap',
        link: '/surucu-basvuru',
        tone: 'secondary',
      }}
    />
  );
}
